<template>
  <div class="project">
    <headerMain></headerMain>
    <el-main>
      <div class="title">
        <p class="title1">PROJECT LIST</p>
        <p class="title2">请选择项目</p>
      </div>
      <div class="right-search-box">
        <div class="right-search">
          <el-input placeholder="请输入项目名称" prefix-icon="el-icon-search" v-model="search" clearable>
          </el-input>
          <el-button type="primary" class="search" @click="searchHandle">搜索</el-button>
        </div>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in projectList" :key="index" @click="toDetail(item.id)">
          <img class="left" src="../assets/images/icon/left_cover.png" alt="">
          <img class="right" src="../assets/images/icon/right_icon.png" alt="">
          <!--  -->
          <el-tooltip v-if="item.projectName.length>7" class="item" effect="dark" :content="item.projectName" placement="bottom">
            <!-- <el-button>下边</el-button> -->
            <div class="top text-one tool-inner">{{ item.projectName }}</div>
          </el-tooltip>
          <div v-else class="top text-one">{{ item.projectName }}</div>
          <span class="bottom">创建时间: {{item.createTime.slice(0,11)}}</span>
        </div>
      </div>
      <div style="margin-right: 40px;position: fixed;    bottom: 20px;right: 0;">系统版本号：v0.2.0</div>
    </el-main>
  </div>
</template>

<script>
import headerMain from "../components/headerMain";
export default {
  name: "login",
  data() {
    return {
      notifications: {},
      projectList: [],
      resourceLists: [],
      search: "",
    };
  },
  components: { headerMain },
  created() {
    this.getProjectList();
    this.getlist();
    this.getAccessToken();
  },
  watch: {
    search(v) {
      if (!v) {
        this.getProjectList();
      }
    },
  },
  methods: {
    // 获取视屏界面的token
    getAccessToken() {
      this.$http
        .post("/bma-distribution-service/video/getAccessToken", {
          type: 1,
        })
        .then((res) => {
          localStorage.accessToken = res.data;
          this.$store.commit("setAccessToken", res.data);
        })
        .catch((error) => {
          // console.log("error: ", error);
        });
    },
    searchHandle() {
      this.getProjectList();
    },
    getProjectList() {
      let userInfo = this.$getCookie("userInfo");
      let id = JSON.parse(userInfo).userId;
      this.$http
        .post("bma-user-service/project/searchUserProjects", {
          userId: id,
          projectName: this.search,
        })
        .then((res) => {
          if (res.data.length > 0) {
            this.projectList = res.data;
          } else {
            if (!this.search) {
              this.$router.push("/super");
            } else {
              this.projectList = [];
            }
          }
        });
    },
    getlist() {
      let userInfo = this.$getCookie("userInfo");
      let id = JSON.parse(userInfo).userId;
      this.$http
        .post("bma-user-service/user/web/searchRoleResourcesByUserForWeb", {
          userId: id,
        })
        .then((res) => {
          // console.log("列表信息", res);
          let resourceIds = [];
          let menuSon = [];
          if (res.data && res.data.length > 0) {
            res.data[0].children.forEach((item) => {
              if (item.resourceId === 3) {
                item.children.forEach((son) => {
                  menuSon.push(son.resourceId);
                });
              }
              if (item.resourceId === 4) {
                item.children.forEach((son) => {
                  menuSon.push(son.resourceId);
                });
              }
              resourceIds.push(item.resourceId);
            });
          }
          // console.log(menuSon);
          // 要求强制刷新时，菜单也存在
          localStorage.menuSon = menuSon;
          // this.$store.commit("setMenuChildren", menuSon);
          document.cookie = "resourceIds=" + resourceIds;
          this.resourceLists = resourceIds;
        });
    },
    toDetail(id) {
      document.cookie = "projectId=" + id;
      localStorage.projectId = id;
      // searchRoleResourcesByUserForWeb   通过这个接口判断有没有对应的菜单，如果有的话，就跳转到对应的页面
      this.resourceLists.forEach((son) => {
        // // console.log(son)
        if (son === 8) {
          this.$router.push("/all/user");
        } else {
          this.$router.push("/all/general");
        }
      });
    },
    makeSure(id) {
      this.notifications[id].close();
      delete this.notifications[id];
    },
    open(id) {
      const _this = this;
      let notify = this.$notify({
        title: "智能配电项目告警",
        dangerouslyUseHTMLString: true,
        duration: 0,
        message: this.$createElement("div", null, [
          this.$createElement(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
              },
            },
            [
              this.$createElement(
                "div",
                {
                  style: {
                    fontWeight: 600,
                  },
                },
                "总配电室"
              ),
              this.$createElement("div", null, "2020-11-10  12:20:11"),
            ]
          ),
          this.$createElement(
            "div",
            {
              style: {
                borderBottom: "1px solid #EBEBEB",
                paddingBottom: "15px",
              },
            },
            "总配电室2011段主总段主段主主段主主总段总配2011段主断路器柜主段主器柜主段主器。"
          ),
          this.$createElement(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                lineHeight: "40px",
              },
            },
            [
              this.$createElement(
                "div",
                {
                  style: {
                    width: "50%",
                    cursor: "pointer",
                    textAlign: "center",
                  },
                  on: {
                    click: _this.makeSure.bind(_this, id),
                  },
                },
                "确认报警"
              ),
              this.$createElement(
                "div",
                {
                  style: {
                    width: "50%",
                    cursor: "pointer",
                    textAlign: "center",
                    color: "#F36161",
                  },
                  on: {
                    click: _this.makeSure.bind(_this, id),
                  },
                },
                "前往处理"
              ),
            ]
          ),
        ]),
      });
      this.notifications[id] = notify;
    },
  },
};
</script>

<style lang="less" scoped>
.right-search-box {
  width: 35%;
  margin-left: 65%;
  .right-search {
    display: flex;
    .el-input {
      margin-right: 10px;
    }
    .search {
      margin-right: 20px;
    }
  }
}
.project {
  width: 100vw;
  height: 100vh;
  background: #f6f6f8;
  .el-main {
    width: 1140px;
    margin: 0 auto;
    padding: 0;
    .title {
      margin-top: 80px;
      text-align: left;
      margin-left: 20px;
      .title1 {
        font-size: 14px;
        font-weight: 400;
        color: #a1a1a1;
        line-height: 38px;
        letter-spacing: 1px;
      }
      .title2 {
        font-size: 24px;
        font-weight: 500;
        color: #21262d;
        letter-spacing: 4px;
      }
    }
    .list {
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 260px;
        height: 85px;
        border: 2px solid #ffffff;
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 20px;
        cursor: pointer;
        margin-left: 20px;
        position: relative;
        .left {
          height: 100%;
        }
        .right {
          width: 18px;
          height: 18px;
          top: 21px;
          right: 21px;
          position: absolute;
        }
        .top {
          width: 144px;
          font-size: 18px;
          font-weight: 500;
          line-height: 31px;
          height: 30px;
          color: #21262d;
          position: absolute;
          top: 20px;
          left: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .tool-inner {
          top: 14px;
          left: 0px;
        }
        .bottom {
          width: 100%;
          font-size: 12px;
          line-height: 20px;
          color: #919caf;
          position: absolute;
          bottom: 10px;
          left: 20px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.el-notification {
  padding-bottom: 0;
  .el-notification__group {
    width: 100%;
  }
}
</style>